import { render, staticRenderFns } from "./oncall_duties_table.vue?vue&type=template&id=a4b8a16a&scoped=true&lang=pug&"
import script from "./oncall_duties_table.vue?vue&type=script&lang=coffee&"
export * from "./oncall_duties_table.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b8a16a",
  null
  
)

export default component.exports